import * as React from "react";

interface IProps {
    value: string | number;
    label: string;
    children?: React.ReactNode[] | React.ReactNode;
}

class DropdownOption extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return null;
    }
}

export default DropdownOption;


// WEBPACK FOOTER //
// ./src/Components/Dropdown/DropdownOption/DropdownOption.tsx